// Ask once which maps app opens for Walk/Drive, then remember it on this device.
import { h } from './dom.js';
import { load, save, remove } from '../lib/storage.js';
import { suggestedApp } from '../lib/links.js';

const KEY = 'mapsApp';
const APPS = { google: 'Google Maps', apple: 'Apple Maps' };

export const storedApp = () => (APPS[load(KEY, null)] ? load(KEY, null) : null);
export const forgetApp = () => remove(KEY);

/** Resolves to 'google' | 'apple', or null if the dialog is dismissed. */
export function chooseApp(dialog) {
  const remembered = storedApp();
  if (remembered) return Promise.resolve(remembered);

  return new Promise((resolve) => {
    const preferred = suggestedApp(navigator.userAgent);
    const order = preferred === 'apple' ? ['apple', 'google'] : ['google', 'apple'];
    const pick = (app) => {
      save(KEY, app);
      dialog.close();
      resolve(app);
    };
    dialog.replaceChildren(
      h('h2', { id: 'maps-dialog-title' }, 'Open directions in'),
      h('p', { class: 'dialog-sub' }, 'Your choice is remembered on this phone. You can change it from any site card.'),
      h('div', { class: 'dialog-buttons' },
        order.map((app) => h('button', { type: 'button', class: 'big', onclick: () => pick(app) }, APPS[app]))),
      h('button', { type: 'button', class: 'link', onclick: () => dialog.close() }, 'Cancel'));
    dialog.addEventListener('close', () => resolve(storedApp()), { once: true });
    dialog.showModal();
  });
}
